import { removeSavedSetting } from "@store/savedMinerSettings/action";
import { ISavedMinerSetting } from "@store/savedMinerSettings/actionTypes";
import { useSavedSettings } from "@utils/hooks/useSavedSettings";
import { useDispatch } from "react-redux";
import { IListSavedSettingsProps } from "./ListSavedSettings.props";

interface IListSavedSettingsControl {
  readonly savedSettings: ISavedMinerSetting[];

  onDelete(name: ISavedMinerSetting["cloned_miner"]): void;
}

export const useListSavedSettingsControl = (
  props: IListSavedSettingsProps
): IListSavedSettingsControl => {
  const dispatch = useDispatch();
  const savedSettings = useSavedSettings();

  const onDelete = (name: ISavedMinerSetting["cloned_miner"]) => {
    dispatch(removeSavedSetting(name));
  };

  return {
    savedSettings,

    onDelete,
  };
};
